"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTelemetrySender = void 0;
var react_1 = __importDefault(require("react"));
var TelemetryContext_1 = require("../telemetry/TelemetryContext");
var TelemetrySender_1 = require("../telemetry/TelemetrySender");
function useTelemetrySender(eventDefinition, valueHandling, contextOverrides) {
    if (valueHandling === void 0) { valueHandling = 'remove'; }
    var baseContext = react_1.default.useContext(TelemetryContext_1.ReactTelemetryContext);
    var context = react_1.default.useRef(__assign(__assign({}, baseContext), contextOverrides));
    react_1.default.useEffect(function () { context.current = __assign(__assign({}, baseContext), contextOverrides); }, [baseContext, contextOverrides]);
    var sendEvent = react_1.default.useCallback(function (event) {
        try {
            TelemetrySender_1.telemetrySender.sendEvent(__assign(__assign({}, eventDefinition), event), context.current, valueHandling);
        }
        catch (_) {
            return;
        }
    }, [eventDefinition, valueHandling]);
    return sendEvent;
}
exports.useTelemetrySender = useTelemetrySender;
//# sourceMappingURL=useTelemetrySender.js.map